'use client';

import type { ICellRendererParams } from 'ag-grid-community';
import type { TracePreviewDto } from '@terra/shared-contracts-trace';
import { useTranslations } from 'next-intl';
import { Badge } from '../../components/badge';
import { token } from '@terra/ui-styled-system';
import { WithInfinitetableLoadingCellSkeleton } from '../table/WithInfinitetableLoadingCellSkeleton';
import { getStatusIcon } from './trace-status-utils';

export function TraceStatusBadge({
  status,
}: {
  status: TracePreviewDto['status'] | null | undefined;
}) {
  const tExecutions = useTranslations('designSystem.executions');

  if (!status) {
    return null;
  }

  return (
    <Badge
      variant="outline"
      size="sm"
      bg={token('colors.bg.neutral.default')}
      borderColor={token('colors.border.neutral.muted')}
      icon={getStatusIcon(status)}
    >
      {tExecutions(`status.${status}`)}
    </Badge>
  );
}

export function TracesTableStatusCell({
  params,
}: {
  params: ICellRendererParams<TracePreviewDto>;
}) {
  if (!params.data) {
    return <WithInfinitetableLoadingCellSkeleton params={params} />;
  }

  return <TraceStatusBadge status={params.data.status} />;
}
